import React, { Fragment } from 'react';
import PropTypes from "prop-types";
import moment from "moment";
import { currency_symbol, paymentGatewayOptions, stripeInfo } from '../../../server/constants';
import {
    convertTwoDecimalPoint,
    calculateStripeCharges, calculateUPayCharges, _addNotificationError, _addNotification, getPaymentGateway,
    getMurchantPayChargesStatus, numberParce, getLoginParent, getSalesTaxAmount, getSalesTaxRate, getSalesTaxStatus, getTotalAmountIncludeSalesTax, numberOnly, groupBy, calculatePayMayaCharges
} from '../../../server/util'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Modal from 'react-modal';
import NumberBox from '../../Misc/NumericBox';
import PaymentModule from '../../Misc/PaymentModule/index';
import Toggle from 'react-toggle';
import CustomSubmit from '../../Misc/customSubmit';
const paymentMethods = {
    cash: 'Cash',
    check: 'Check',
    creditCard: 'Credit Card',
    onlinePayment: 'Online Payment'
}
const customStyles = {
    content: {
        textAlign: 'justify',
        textJustify: 'inter-word',
        padding: '30px',
        maxHeight: '500px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
let murchantPayChargeStatus = false;

class InstantPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showConformMsg: false,
            showLowBalMsg: false,
            tabIndex: 0,
            checked: false,
            donationChecked: false,
            price: this.props.price || {},
            studentData: this.props.studentData,
            summeryData: this.props.orderDetails,
            donationsData: this.props.schoolData,
            formData: [],
            initialPrices: this.props.initialPrices || {},
            isParent: (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') ? false : true,
            isDonate: '',
            donationPrice: '',
            isTyping: false,
            lunchBal: {
                selected: true,
                balAvAmount: ((this.props || {}).studentData || {}).accBalance || 0.00,
                amount: 0.00
            },
            paymentObj: {
                fullAmount: 0.00,
                paidEditPrice: 0.00,
                balAmount: 0.00,
                charges: 0.00,
                donationAmt: 0.00,
                donationNoOfMeals: '',
                paymentType: 'Cash',
                checkNum: '',
                showStripeBtn: false,
                conformAmt: 0.00,
                showBalInfo: false
            },
        }
        this.isNumeric = this.isNumeric.bind(this)
    }
    isNumeric = (evt) => {
        var iKeyCode = (evt.which) ? evt.which : evt.keyCode
        if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
            evt.preventDefault();
        else {
            if (iKeyCode === 46) {
                var existingVal = evt.target.value;
                if ((existingVal + '').indexOf(".") !== -1) {
                    evt.preventDefault();
                }
            }
        }
    }
    componentWillMount = () => {
        const { donationsData, studentData } = this.state;
        Object.keys(donationsData || []).map((key) => {
            if (key == studentData.mSchoolId) {
                let donationStatus = donationsData[key] || {}
                let _status = donationStatus.isDonationAccept;
                let _donationPrice = donationStatus.donationPrice;
                this.setState({ isDonate: _status, donationPrice: _donationPrice })
            }
        });
        this.balToPay();
    }
    componentWillReceiveProps = (nextProps) => {
        const walletAmt = nextProps.studentData.accBalance;
        const { lunchBal } = this.state;
        lunchBal.balAvAmount = walletAmt;
        this.setState({
            price: (nextProps.price || {}),
            studentData: nextProps.studentData,
            initialPrices: nextProps.initialPrices,
            lunchBal
        }, () => {
            this.balToPay();
        });
    }
    donationPrice = () => {
        const { donationAmt, donationNoOfMeals } = this.state.paymentObj;
        const { donationPrice, donationChecked } = this.state
        if (donationChecked) {
            if (donationAmt) {
                return parseFloat(donationAmt)
            } else {
                let donationMealPrice = donationNoOfMeals * donationPrice
                return (donationMealPrice);
            }
        }
        else {
            return 0
        }
    }
    balToPay = () => {
        const { lunchBal, paymentObj, studentData, isParent } = this.state;
        const { isPrePayForOrderStatus } = this.props;
        if (isParent) {
            murchantPayChargeStatus = isParent ? getMurchantPayChargesStatus(studentData.mealSchoolId || 0) : false
            let _conformAmt = parseFloat(numberParce(paymentObj.conformAmt));
            let bToPay = parseFloat(convertTwoDecimalPoint((this.totalOrderAmount() - _conformAmt) + this.donationPrice(), 2));
            paymentObj.paidEditPrice = this.totInitPrice();
            if (lunchBal.balAvAmount < 0) {
                lunchBal.selected = true;
                let bal = parseFloat(convertTwoDecimalPoint((bToPay + -((lunchBal.balAvAmount))), 2)); //+this.donationPrice();
                paymentObj.balAmount = bal;
                if (this.state.tabIndex === 0 && this.state.isParent) {
                    if (bal <= 0) {
                        paymentObj.charges = 0.00;
                        paymentObj.showStripeBtn = false;
                    } else {
                        if (isPrePayForOrderStatus) {
                            paymentObj.charges = 0.00;
                        } else {
                            if (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                paymentObj.charges = 0;//calculateUPayCharges(bal,false,(this.state.isParent?this.state.studentData.mealSchoolId:0));
                            } else if (paymentGatewayOptions.PAYMAYA === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                paymentObj.charges = 0;//calculateUPayCharges(bal,false,(this.state.isParent?this.state.studentData.mealSchoolId:0));
                            }
                            else if (paymentGatewayOptions.STRIPE === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                paymentObj.charges = calculateStripeCharges(bal, true, (this.state.isParent ? this.state.studentData.mealSchoolId : 0));
                            } else {
                                paymentObj.charges = 0.00;
                            }
                        }
                        paymentObj.paymentType = 'Online';
                        paymentObj.showStripeBtn = true;
                    }
                }
            } else {
                if (bToPay === 0 && !(this.state.isDonate)) {
                    lunchBal.selected = false;
                    paymentObj.balAmount = bToPay;
                } else {
                    if (lunchBal.selected && lunchBal.balAvAmount > 0) {
                        let bal1 = (bToPay > lunchBal.balAvAmount) ? (bToPay - lunchBal.balAvAmount) : - (lunchBal.balAvAmount - bToPay);
                        bal1 = parseFloat(convertTwoDecimalPoint(bal1, 2));
                        if (bal1 < 0) {
                            paymentObj.balAmount = 0.00;
                            lunchBal.amount = parseFloat(convertTwoDecimalPoint(bToPay));
                        } else {
                            paymentObj.balAmount = bal1;
                            lunchBal.amount = parseFloat(convertTwoDecimalPoint(lunchBal.balAvAmount));
                        }
                    } else {
                        if (isPrePayForOrderStatus) {
                            lunchBal.selected = true;
                        } else {
                            if (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                lunchBal.selected = true;
                            } else if (paymentGatewayOptions.PAYMAYA === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                // lunchBal.selected=true;
                            } else {
                                lunchBal.selected = false;
                            }
                        }
                        lunchBal.amount = 0.00;
                        paymentObj.balAmount = bToPay;
                    }
                }
                if (this.state.tabIndex === 0 && this.state.isParent) {
                    let bal = 0.00;
                    if (lunchBal.selected) {
                        bal = (bToPay > lunchBal.balAvAmount) ? (bToPay - lunchBal.balAvAmount) : - (lunchBal.balAvAmount - bToPay);
                        bal = parseFloat(convertTwoDecimalPoint(bal, 2));
                    } else {
                        if (this.state.donationChecked) {
                            bal = bToPay
                        }
                        else {
                            bal = bToPay
                        };
                    }
                    if (bal <= 0) {
                        paymentObj.charges = 0.00;
                        paymentObj.showStripeBtn = false;
                    } else {
                        if (isPrePayForOrderStatus) {
                            paymentObj.charges = 0;
                        } else {
                            if (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                paymentObj.charges = 0;//calculateUPayCharges(bal,false,(this.state.isParent?this.state.studentData.mealSchoolId:0));
                            } else if (paymentGatewayOptions.PAYMAYA === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                //paymentObj.charges=0;//calculateUPayCharges(bal,false,(this.state.isParent?this.state.studentData.mealSchoolId:0));
                                paymentObj.charges = calculatePayMayaCharges(bal, false, (this.state.isParent ? this.state.studentData.mealSchoolId : 0));
                            }
                            else if (paymentGatewayOptions.STRIPE === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                paymentObj.charges = calculateStripeCharges(bal, true, (this.state.isParent ? this.state.studentData.mealSchoolId : 0));
                            } else {
                                paymentObj.charges = 0.00;
                            }
                        }
                        paymentObj.paymentType = 'Online';
                        paymentObj.balAmount = bal;
                        paymentObj.showStripeBtn = true;
                    }
                }
            }
            this.setState({ paymentObj: { ...paymentObj, balAmount: parseFloat(convertTwoDecimalPoint(paymentObj.balAmount, 2)) }, lunchBal: lunchBal });
        } else {
            let _confAmt = parseFloat(numberParce(paymentObj.conformAmt).toFixed(2));
            let oPay = this.totalOrderAmount();
            if (lunchBal.balAvAmount <= 0) {
                lunchBal.selected = false;
                const balAmt = parseFloat((oPay - _confAmt).toFixed(2));
                if (balAmt < 0) {
                    lunchBal.amount = 0;
                    paymentObj.balAmount = balAmt
                } else {
                    lunchBal.amount = balAmt;
                    paymentObj.balAmount = balAmt
                }
            } else {
                const balAmt = parseFloat((oPay - _confAmt).toFixed(2));
                if (balAmt <= 0) {
                    lunchBal.amount = 0;
                    paymentObj.balAmount = balAmt
                } else {
                    lunchBal.amount = balAmt;
                    let balVal = (balAmt > lunchBal.balAvAmount) ? (balAmt - lunchBal.balAvAmount) : - (lunchBal.balAvAmount - balAmt);
                    paymentObj.balAmount = balVal;
                }
            }
            this.setState({ paymentObj: { ...paymentObj, balAmount: parseFloat(convertTwoDecimalPoint(paymentObj.balAmount, 2)) }, lunchBal: lunchBal });
        }
    }
    walletSection = () => {
        const { isParent, isDonate } = this.state;
        const { isPrePayForOrderStatus } = this.props;
        return <div className="row">
            <div className="col-md-8">
                <div className="form-group">
                    {isParent ?
                        <div> <div className="checkbox">
                            <label>
                                <input type="checkbox" checked={this.state.lunchBal.selected} onChange={(e) => {
                                    let _lunchBal = this.state.lunchBal;
                                    if (isPrePayForOrderStatus) {
                                        _lunchBal.selected = true;
                                    } else {
                                        if (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                            _lunchBal.selected = true;
                                        } else if (paymentGatewayOptions.PAYMAYA === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                                            // _lunchBal.selected=true;
                                            _lunchBal.selected = e.target.checked ? true : false;
                                        } else {
                                            _lunchBal.selected = e.target.checked ? true : false;
                                        }
                                    }
                                    this.setState({ lunchBal: _lunchBal }, () => {
                                        this.balToPay();
                                    });
                                }} /><span className="label-text">Meal Account Balance </span>
                            </label>
                        </div>
                            {isDonate && <div> <label><span className="label-text">Donations</span></label></div>}
                        </div>
                        :
                        <div>  <div><label><span className="label-text">Meal Account Balance</span></label></div>
                            {isDonate && <div> <label><span className="label-text">Donations</span></label></div>}
                        </div>
                    }

                </div>
            </div> {isParent ?
                <div> <div className="col-md-4 text-right" style={{ marginTop: "6px" }}>
                    <span className="label-text">{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.state.lunchBal.balAvAmount, 2)}`}</span>
                </div>

                    {isDonate && <div className="col-md-4 text-right" style={{ marginTop: "18px" }}>
                        <span className="label-text">{this.props.currency_symbol}{this.donationPrice()}</span>
                    </div>}</div> : <div> <div className="col-md-4 text-right">
                        <span className="label-text">{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.state.lunchBal.balAvAmount, 2)}`}</span>
                    </div>

                    {isDonate && <div className="col-md-4 text-right" style={{ marginTop: "8px" }}>
                        <span className="label-text">{this.props.currency_symbol}{this.donationPrice()}</span>
                    </div>}</div>}
        </div>
    }
    totalOrderAmount = () => {
        let totPrice = 0.00;
        Object.keys(this.state.price).map((priceItem, i) => {
            totPrice += this.monthlyAmount(this.state.price[priceItem], 'TOTAL');
        })
        return (totPrice) - this.totInitPrice();
    }
    totInitPrice = () => {
        let prevPaid = 0.00;
        Object.keys(this.state.initialPrices).map((priceItem, i) => {
            prevPaid += this.monthlyAmount(this.state.initialPrices[priceItem], 'TOTAL');
        })
        return prevPaid;
    }
    monthlyAmount = (price, action) => {
        const { studentData, isParent } = this.state;
        const initPrice = parseFloat(convertTwoDecimalPoint(price, 1));
        const sid = isParent ? studentData.mealSchoolId || 0 : 0;
        if (getSalesTaxStatus(sid)) {
            if (action === 'TOTAL') {
                return getTotalAmountIncludeSalesTax(initPrice, getSalesTaxRate(sid))
            } else {
                return getSalesTaxAmount(initPrice, getSalesTaxRate(sid))
            }
        } else {
            return initPrice
        }
    }
    totalOrderAmountExcludeSalesTax = () => {
        let totPrice = 0.00;
        Object.keys(this.state.price).map((priceItem, i) => {
            totPrice += parseFloat(convertTwoDecimalPoint(this.state.price[priceItem], 2));
        })
        return (totPrice) - this.totInitPriceExcludeSalesTax();
    }
    totInitPriceExcludeSalesTax = () => {
        let prevPaid = 0.00;
        Object.keys(this.state.initialPrices).map((priceItem, i) => {
            prevPaid += parseFloat(convertTwoDecimalPoint(this.state.initialPrices[priceItem], 2));
        })
        return prevPaid;
    }
    calculateSalesTax = () => {
        const { isParent, studentData } = this.props;
        const saleTaxAmount = getSalesTaxAmount(this.totalOrderAmountExcludeSalesTax(), getSalesTaxRate(isParent ? studentData.mealSchoolId : 0));
        if (this.totalOrderAmountExcludeSalesTax() <= 0) {
            return 0.00;
        } else {
            return saleTaxAmount;
        }
    }
    paymentAmtCtrl = () => {
        return (<Fragment>
            <div className="row">
                <div className="col-md-5"> {
                    this.state.paymentObj.paymentType == "Check" ? "Check Amount Received"
                        : this.state.paymentObj.paymentType == "CreditCard" ? "Card Payment Received"
                            : "Cash Received"
                }</div>
                <div className="col-md-3">
                    {
                        this.state.paymentObj.paymentType == "Check" || this.state.paymentObj.paymentType == "CreditCard" ?
                            <input type="text" className="form-control" value={this.state.paymentObj.checkNum} placeholder={this.state.paymentObj.paymentType == "Check" ? "Check No" : "Ref No"} onChange={(e) => {
                                const { paymentObj } = this.state;
                                paymentObj['checkNum'] = e.target.value;
                                this.setState({ paymentObj });
                            }} /> : null
                    }
                </div>
                <div className="col-md-4">
                    <div className="form-group">
                        <div className="input-group">
                            <span className="input-group-addon">{`${this.props.currency_symbol}`}</span>
                            <NumberBox type="text" className="form-control" maxLength="6"
                                value={this.state.paymentObj.conformAmt}
                                id="conformAmt" name="conformAmt" placeholder="0.00" style={{ textAlign: 'right' }}
                                onChange={(e) => {
                                    const _paymentObj = { ...this.state.paymentObj };
                                    _paymentObj.conformAmt = e.target.value;
                                    _paymentObj.showBalInfo = true;
                                    this.setState({ paymentObj: { ..._paymentObj, balAmount: parseFloat(convertTwoDecimalPoint(_paymentObj.balAmount, 2)) } }, () => {
                                        this.balToPay()
                                    });
                                }} noValidate />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-5">
                    Balance amount to pay
                </div>
                <div className="col-md-3">

                </div>
                <div className="col-md-4 text-right">
                    <span className="label-text">{`${this.props.currency_symbol} ${numberParce(this.state.paymentObj.balAmount) < 0 ? "0.00" : (convertTwoDecimalPoint((this.state.paymentObj.balAmount + this.donationPrice()), 2))}`}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-center" >
                    {
                        this.state.paymentObj.balAmount < 0 && this.state.paymentObj.showBalInfo ?
                            <span style={{ fontiSze: '13px', color: 'red', fontStyle: 'italic' }}>Balance amount <strong>{`${this.props.currency_symbol} ${numberParce(-1 * this.state.paymentObj.balAmount - this.donationPrice()).toFixed(2)}`}</strong> will be credited to student Meal Account.</span> :
                            this.state.paymentObj.balAmount > 0 && this.state.paymentObj.showBalInfo ?
                                <span style={{ fontiSze: '13px', color: 'red', fontStyle: 'italic' }}>Balance amount <strong>{`${this.props.currency_symbol} ${numberParce(this.state.paymentObj.balAmount - this.donationPrice()).toFixed(2)}`}</strong>  will be debited from student Meal Account.</span> :
                                null
                    }
                </div>
            </div>
        </Fragment>
        )
    }
    buildTabs = (props) => {
        const { isPrePayForOrderStatus } = this.props
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-8">
                        <label>Total order amount</label>
                    </div>
                    <div className="col-md-4 text-right">
                        <span className="label-text">{`${this.props.currency_symbol} ${convertTwoDecimalPoint((this.totalOrderAmount()), 2)}`}</span>
                    </div>
                </div>
                <hr style={{ margin: '7px 0px' }} />
                {
                    this.walletSection()
                }
                <div className="row">
                    <div className="col-md-12">
                        <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
                            <TabList>
                                {
                                    !this.state.isParent ?
                                        <Fragment>
                                            <Tab onClick={() => {
                                                const { paymentObj } = this.state;
                                                paymentObj.paymentType = "Cash";
                                                paymentObj.checkNum = "";
                                                this.setState(paymentObj);
                                            }}>{paymentMethods.cash}</Tab>
                                            <Tab onClick={() => {
                                                const { paymentObj } = this.state;
                                                paymentObj.paymentType = "Check";
                                                paymentObj.checkNum = "";
                                                this.setState(paymentObj);
                                            }}>{paymentMethods.check}</Tab>
                                            <Tab onClick={() => {
                                                const { paymentObj } = this.state;
                                                paymentObj.paymentType = "CreditCard";
                                                paymentObj.checkNum = "";
                                                this.setState(paymentObj);
                                            }}>{paymentMethods.creditCard}</Tab>
                                        </Fragment> : null
                                }
                                {
                                    (this.state.isParent && ((paymentGatewayOptions.PAYMOB !== getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || ''))) ? <Tab>{paymentMethods.onlinePayment}</Tab> : null
                                }
                            </TabList>
                            {
                                !this.state.isParent ?
                                    <Fragment>
                                        <TabPanel>
                                            {
                                                this.paymentAmtCtrl()
                                            }

                                        </TabPanel>
                                        <TabPanel>
                                            {
                                                this.paymentAmtCtrl()
                                            }

                                        </TabPanel>
                                        <TabPanel>
                                            {
                                                this.paymentAmtCtrl()
                                            }
                                        </TabPanel>
                                    </Fragment> : null
                            }
                            {
                                this.state.isParent ?
                                    <TabPanel>
                                        <div className="row">
                                            <div className="col-md-8">
                                                Amount to Pay
                                            </div>
                                            <div className="col-md-4 text-right">
                                                <span className="label-text">{`${this.props.currency_symbol} ${convertTwoDecimalPoint((this.state.paymentObj.balAmount), 2)}`}</span>
                                            </div>
                                        </div>
                                        {
                                            (isPrePayForOrderStatus) ? <Fragment>
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        Total Payment Amount
                                                    </div>
                                                    <div className="col-md-4 text-right">
                                                        <span className="label-text">{`${this.props.currency_symbol}  ${((murchantPayChargeStatus ? 0.00 : parseFloat(convertTwoDecimalPoint(this.state.paymentObj.charges, 2))) + parseFloat(convertTwoDecimalPoint((this.state.paymentObj.balAmount), 2))).toFixed(2)}`}</span>
                                                    </div>
                                                </div>
                                            </Fragment>
                                                :
                                                (paymentGatewayOptions.STRIPE === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') ?
                                                    <Fragment>
                                                        <div className="row" style={{ display: `${murchantPayChargeStatus ? 'none' : 'block'}` }}>
                                                            <div className="col-md-8">
                                                                Transaction charges
                                                            </div>
                                                            <div className="col-md-4 text-right">
                                                                <span className="label-text">{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.state.paymentObj.charges, 2)}`}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <hr style={{ margin: '10px 0px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-8">
                                                                Total Payment Amount
                                                            </div>
                                                            <div className="col-md-4 text-right">
                                                                <span className="label-text">{`${this.props.currency_symbol}  ${((murchantPayChargeStatus ? 0.00 : parseFloat(convertTwoDecimalPoint(this.state.paymentObj.charges, 2))) + parseFloat(convertTwoDecimalPoint((this.state.paymentObj.balAmount), 2))).toFixed(2)}`}</span>
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                    :
                                                    (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') ?
                                                        <Fragment>
                                                            <div className="row">
                                                                <div className="col-md-8">
                                                                    Total Payment Amount
                                                                </div>
                                                                <div className="col-md-4 text-right">
                                                                    <span className="label-text">{`${this.props.currency_symbol}  ${((murchantPayChargeStatus ? 0.00 : parseFloat(convertTwoDecimalPoint(this.state.paymentObj.charges, 2))) + parseFloat(convertTwoDecimalPoint((this.state.paymentObj.balAmount), 2))).toFixed(2)}`}</span>
                                                                </div>
                                                            </div>
                                                        </Fragment>
                                                        : (paymentGatewayOptions.PAYMAYA === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') ?
                                                            <Fragment>
                                                                <div className="row" style={{ display: `${murchantPayChargeStatus ? 'none' : 'block'}` }}>
                                                                    <div className="col-md-8">
                                                                        Transaction charges
                                                                    </div>
                                                                    <div className="col-md-4 text-right">
                                                                        <span className="label-text">{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.state.paymentObj.charges, 2)}`}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <hr style={{ margin: '10px 0px' }} />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-8">
                                                                        Total Payment Amount
                                                                    </div>
                                                                    <div className="col-md-4 text-right">
                                                                        <span className="label-text">{`${this.props.currency_symbol}  ${((murchantPayChargeStatus ? 0.00 : parseFloat(convertTwoDecimalPoint(this.state.paymentObj.charges, 2))) + parseFloat(convertTwoDecimalPoint((this.state.paymentObj.balAmount), 2))).toFixed(2)}`}</span>
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                            :
                                                            <Fragment>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <hr style={{ margin: '10px 0px' }} />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-8">
                                                                        Total Payment Amount
                                                                    </div>
                                                                    <div className="col-md-4 text-right">
                                                                        <span className="label-text">{`${this.props.currency_symbol}  ${((murchantPayChargeStatus ? 0.00 : parseFloat(convertTwoDecimalPoint(this.state.paymentObj.charges, 2))) + parseFloat(convertTwoDecimalPoint((this.state.paymentObj.balAmount), 2))).toFixed(2)}`}</span>
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                        }
                                    </TabPanel>

                                    : null
                            }
                        </Tabs>
                    </div>
                </div>

            </Fragment>
        )
    }
    onToken = (resp) => {
        this.props.onSubmitPayment(resp);
    }
    adminInstantPaymentSubmit = ({ lunchBal, paymentObj }, callback, conformMsg = true) => {
        this.setState({ loading: true });
        let _formData = this.state.formData[0] || {};
        let conformAmt = parseFloat(numberParce(paymentObj.conformAmt).toFixed(2))
        if (lunchBal.selected) {
            if (conformAmt === 0) {
                _formData['walletAmt'] = lunchBal.amount;
                _formData["paymentType"] = 'Wallet';
            } else {
                _formData['walletAmt'] = lunchBal.amount;
                _formData["paymentType"] = paymentObj.paymentType;
                _formData["instantPayAmt"] = conformAmt;
            }
        } else {
            if (conformAmt === 0) {
                _formData['walletAmt'] = lunchBal.amount;
                _formData["paymentType"] = 'Wallet';
            } else {
                _formData["paymentType"] = paymentObj.paymentType;
                _formData["instantPayAmt"] = conformAmt;
                _formData['walletAmt'] = lunchBal.amount;
            }
        }
        _formData["checkNum"] = paymentObj.checkNum;
        _formData["salesTaxAmt"] = this.calculateSalesTax();
        if (conformMsg) {
            if (paymentObj.balAmount !== 0) {

                this.setState({ showConformMsg: true });
            } else {
                this.props.onSubmitPayment(_formData, callback);
            }
        }
        else {
            this.props.onSubmitPayment(_formData, callback);
        }
    }
    parentInstantPaymetFormObject = ({ lunchBal, paymentObj }) => {
        const { isPrePayForOrderStatus } = this.props;

        let _formData = this.state.formData[0] || {};
        let bal = 0.00;
        if (lunchBal.selected) {
            _formData['walletAmt'] = lunchBal.amount;
            let lBalAmt = paymentObj.balAmount;
            if (lunchBal.balAvAmount < 0) {
                bal = paymentObj.balAmount;
            } else {
                bal = lBalAmt;
                //bal=(paymentObj.balAmount>=lunchBal.balAvAmount)?(paymentObj.balAmount-lunchBal.balAvAmount):paymentObj.balAmount;
            }
            if (lBalAmt <= 0.00) {
                _formData["paymentType"] = 'Wallet';
                _formData["instantPayAmt"] = 0.00;
            } else {
                _formData["paymentType"] = paymentObj.paymentType;
                _formData["instantPayAmt"] = parseFloat(convertTwoDecimalPoint(bal, 2));
            }
        } else {
            bal = paymentObj.balAmount;
            _formData['walletAmt'] = 0.00;
            _formData["paymentType"] = paymentObj.paymentType;
            _formData["instantPayAmt"] = parseFloat(convertTwoDecimalPoint(bal, 2));
        }
        if (this.state.donationChecked) {
            _formData['donationAmt'] = paymentObj.donationAmt;
            _formData['donationNoOfMeals'] = paymentObj.donationNoOfMeals;
        } else {
            _formData['donationAmt'] = 0;
            _formData['donationNoOfMeals'] = '';
        }
        _formData["checkNum"] = paymentObj.checkNum;
        _formData["salesTaxAmt"] = this.calculateSalesTax();
        return { _formData, bal };
    }
    parentInstantPaymetSubmit = ({ lunchBal, paymentObj }, callback, conformMsg = true) => {
        const { isPrePayForOrderStatus } = this.props;
        this.setState({ loading: true });
        const formRes = this.parentInstantPaymetFormObject({ lunchBal, paymentObj });
        const { _formData, bal } = formRes || {};
        if (conformMsg) {
            if (bal > 0) {
                if (isPrePayForOrderStatus) {
                    this.setState({ showLowBalMsg: true });
                } else if (paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                    this.setState({ showLowBalMsg: true });
                } else if (paymentGatewayOptions.PAYMAYA === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || '') {
                    this.setState({ showLowBalMsg: true });
                } else {
                    this.setState({ showConformMsg: true });
                }
            } else {
                this.props.onSubmitPayment(_formData, callback);
            }
        } else {
            this.props.onSubmitPayment(_formData, callback);
        }
        //this.props.onSubmitPayment(_formData);
    }
    showHideLoading = (isShow) => {
        this.props.showHideLoading(isShow)
    }
    renderDonationPartners = () => {
        const { donationObject } = this.props;
        const donationPartners = (donationObject || {}).donationPartners || [];
        const percentageGroup = groupBy(donationPartners, 'percentageMatch');
        return <Fragment>{donationPartners.length > 0 &&
            <div className='col-md-12 text-center'>
                <div style={{ marginBottom: '20px', marginTop: '10px', fontSize: '18px', textAlign: 'left' }}><b><span>{`Now your donations are matched by our corporate partners.`}</span></b></div>
                {
                    Object.keys(percentageGroup).map((per, i) => {
                        return <div style={{ display: 'inline-flex', paddingLeft: '5px' }}>
                            <div>
                                <ul style={{ listStyle: 'none' }}>
                                    {
                                        (percentageGroup[per] || []).map((donationRec, i) => {
                                            return <li style={{ float: 'left', marginRight: '15px', width: '170px', height: '87px', textAlign: 'center' }}>
                                                <a href={donationRec.donationPartnerURL} target='_blank'>
                                                    <img src={donationRec.donationPartnerImageURL} alt={donationRec.donationPartnerName}
                                                        style={{ verticalAlign: 'middle', width: '100%', marginBottom: '5px' }} />
                                                </a><br />
                                                <b><span>{`Up to ${per}% Match`}</span></b>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    })
                }
            </div>
        } </Fragment>

    }

    render() {
        const { isParent, price, studentData, initialPrices, lunchBal, paymentObj, isDonate, donationPrice } = this.state;
        const { isPrePayForOrderStatus, donationObject } = this.props;

        return (<Fragment>
            <div className='row' style={{ margin: '10px auto' }}>
                <div className="col-xs-12 col-md-4" >
                    <div className="text-left" >
                        <h4 style={{ marginBottom: '3px' }}>{'Payment Summary'}</h4>
                    </div>
                </div>
                <div className='col-xs-12 col-md-8 text-right'>

                    <button type="button" className="btn btn-sm btn-info" style={window.innerWidth <= 500 ? { width: '100%' } : {}} onClick={(e) => {
                        this.props.onBackOrderReview(e)
                    }}>Back to Review Order</button>
                    {
                        this.state.isParent && isPrePayForOrderStatus ?
                            <CustomSubmit id="orderSubmit" type="button" className="btn btn-success btn-lg"
                                style={window.innerWidth <= 500 ? { width: '100%', margin: 0, marginLeft: 5, fontSize: 14, } : {
                                    margin: 0, marginLeft: 5, fontSize: 14,
                                }}
                                handleSubmit={(e, callback) => {
                                    if (this.state.isParent) {
                                        this.parentInstantPaymetSubmit({ lunchBal, paymentObj }, callback)
                                    } else {
                                        this.adminInstantPaymentSubmit({ lunchBal, paymentObj }, callback)
                                    }
                                    //this.onStudentDataSubmit(e,callback)
                                }}>
                                <i className="glyphicon glyphicon-ok"></i> Pay</CustomSubmit>
                            :

                            this.state.isParent && (paymentObj.showStripeBtn && (!(paymentGatewayOptions.UNIONPAY === getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName || ''))
                                //&& (!(paymentGatewayOptions.PAYMAYA ===getPaymentGateway(this.state.studentData.mealSchoolId).payGatewayName||''))
                            ) ?
                                <PaymentModule {...this.props}
                                    paymentDesc={"ORDER_PAY"}
                                    userInfo={{
                                        parent: getLoginParent()
                                    }}
                                    formData={this.state.formData}
                                    schoolId={this.props.studentData.mealSchoolId}
                                    schoolName={this.props.studentData.schoolName}
                                    lunchBal={lunchBal}
                                    paidEditPrice={this.totInitPrice()}
                                    excludeCharges={murchantPayChargeStatus}
                                    paymentObj={{
                                        ...paymentObj, orderDate: moment(),
                                        menuOrderData: {
                                            ...this.props.prepareSaveObject(this.calculateSalesTax(), this.parentInstantPaymetFormObject({ lunchBal, paymentObj })),
                                            //lunchBal: { ...lunchBal }, 
                                            menuType: this.props.mealType
                                        }
                                    }}
                                    monthYear={this.state.monthYear}
                                    postDataForPayMaya={
                                        () => {
                                            let _formData = {};
                                            const _stripeInfo = stripeInfo(this.props.studentData.mealSchoolId);

                                            if (lunchBal.selected) {
                                                //bal=(paymentObj.balAmount>lunchBal.balAvAmount)?(paymentObj.balAmount-lunchBal.balAvAmount):0
                                                _formData['walletAmt'] = lunchBal.amount;
                                            }
                                            _formData["paymentType"] = "Online";
                                            _formData["parentUserEmails"] = sessionStorage.getItem('loggedInUserInfo');
                                            _formData["instantPayAmt"] = parseFloat(convertTwoDecimalPoint(paymentObj.balAmount, 2));
                                            _formData["transactionFees"] = parseFloat(parseFloat(convertTwoDecimalPoint(calculatePayMayaCharges(paymentObj.balAmount, false), 2)));
                                            _formData["appFeeAmount"] = 0;
                                            return this.props.saveMenuForUnionPay(_formData);

                                        }
                                    }
                                    postDataForUnionPay={() => {
                                        let _formData = {};
                                        const _stripeInfo = stripeInfo(this.props.studentData.mealSchoolId);

                                        if (lunchBal.selected) {
                                            //bal=(paymentObj.balAmount>lunchBal.balAvAmount)?(paymentObj.balAmount-lunchBal.balAvAmount):0
                                            _formData['walletAmt'] = lunchBal.amount;
                                        }
                                        _formData["paymentType"] = "Online";
                                        _formData["parentUserEmails"] = sessionStorage.getItem('loggedInUserInfo');
                                        _formData["instantPayAmt"] = parseFloat(convertTwoDecimalPoint(paymentObj.balAmount, 2));
                                        _formData["transactionFees"] = parseFloat(convertTwoDecimalPoint((paymentObj.charges - parseFloat(convertTwoDecimalPoint(calculateUPayCharges(paymentObj.balAmount, false)))), 2));
                                        _formData["appFeeAmount"] = parseFloat(convertTwoDecimalPoint(calculateUPayCharges(paymentObj.balAmount, false)));
                                        return this.props.saveMenuForUnionPay(_formData);
                                    }}
                                    onToken={(token) => {
                                        let _formData = {};
                                        const _stripeInfo = stripeInfo(this.props.studentData.mealSchoolId);
                                        if (typeof (token) === 'string') {
                                            _formData["transactionToken"] = token;
                                        }
                                        else {
                                            _formData["transferId"] = token.transferId;
                                            _formData["chargeId"] = token.chargeId;
                                            _formData['doOrderMenuCall'] = token.doOrderMenuCall || '';
                                        }
                                        if (lunchBal.selected) {
                                            //bal=(paymentObj.balAmount>lunchBal.balAvAmount)?(paymentObj.balAmount-lunchBal.balAvAmount):0
                                            _formData['walletAmt'] = lunchBal.amount;
                                        }
                                        _formData["paymentType"] = "Online";
                                        _formData["parentUserEmails"] = sessionStorage.getItem('loggedInUserInfo');
                                        _formData["instantPayAmt"] = parseFloat(convertTwoDecimalPoint(paymentObj.balAmount, 2));
                                        _formData["transactionFees"] = parseFloat(convertTwoDecimalPoint((paymentObj.charges - parseFloat(convertTwoDecimalPoint(_stripeInfo.application_free))), 2));
                                        _formData["appFeeAmount"] = _stripeInfo.application_free;
                                        if (this.state.donationChecked) {
                                            _formData['donationAmt'] = paymentObj.donationAmt;
                                            _formData['donationNoOfMeals'] = paymentObj.donationNoOfMeals;
                                        } else {
                                            _formData['donationAmt'] = 0;
                                            _formData['donationNoOfMeals'] = '';
                                        }
                                        this.onToken(_formData);
                                    }
                                    }
                                    //onPaymentDone={this.onPaymentDone} 
                                    showHideLoading={this.showHideLoading}
                                    onValidationError={(error) => {
                                        _addNotificationError(error, this.props);
                                    }}
                                    disabled={this.props.loading}
                                /> :
                                <CustomSubmit id="orderSubmit" type="button" className="btn btn-success btn-lg"
                                    style={window.innerWidth <= 500 ? { width: '100%', margin: 0, marginLeft: 5, fontSize: 14, } : {
                                        margin: 0, marginLeft: 5, fontSize: 14,
                                    }}
                                    handleSubmit={(e, callback) => {
                                        if (this.state.isParent) {
                                            this.parentInstantPaymetSubmit({ lunchBal, paymentObj }, callback)
                                        } else {
                                            this.adminInstantPaymentSubmit({ lunchBal, paymentObj }, callback)
                                        }
                                        //this.onStudentDataSubmit(e,callback)
                                    }}>
                                    <i className="glyphicon glyphicon-ok"></i> Pay and Submit Order</CustomSubmit>

                    }

                </div>
            </div>
            <div className="row">
                <div className="col-md-7">
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Month Year</th>
                                    <th style={{ width: '150px', textAlign: 'right' }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Object.keys(price).map((priceItem, i) => {
                                        return <Fragment>
                                            <tr>
                                                <td>{moment(priceItem, 'YYYYMM').format('MMM-YY')}</td>
                                                <td style={{ width: '150px', textAlign: 'right' }}>{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.monthlyAmount(price[priceItem], 'TOTAL'), 2)}`}</td>
                                            </tr>
                                            {
                                                ((initialPrices[priceItem]) || 0) > 0 &&
                                                <tr>
                                                    <td>{`Already paid on ${moment(priceItem, 'YYYYMM').format('MMM-YY')}`}</td>
                                                    <td style={{ width: '150px', textAlign: 'right' }}>{`(-) ${this.props.currency_symbol} ${convertTwoDecimalPoint(this.monthlyAmount(initialPrices[priceItem], 'TOTAL'), 2)}`}</td>
                                                </tr>
                                            }
                                        </Fragment>
                                    })
                                }
                            </tbody>
                            <tfoot style={{ backgroundColor: '#f7f6f6', fontWeight: 600 }}>
                                {
                                    getSalesTaxStatus(isParent ? studentData.mealSchoolId : 0) ?
                                        <tr>
                                            <td>Sales Tax</td>
                                            <td style={{ width: '150px', textAlign: 'right' }}>{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.calculateSalesTax(), 2)}`}</td>
                                        </tr> :
                                        null
                                }
                                <tr>
                                    <td>Total Amount</td>
                                    <td style={{ width: '150px', textAlign: 'right' }}>{`${this.props.currency_symbol} ${convertTwoDecimalPoint(this.totalOrderAmount(), 2)}`}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    {isDonate && <div className='col-md-12' style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <div className="row alert-success">
                            <Fragment>
                                {
                                    this.renderDonationPartners()
                                }
                            </Fragment>
                        </div>
                    </div>}
                    {isDonate && <div>

                        <Toggle
                            checked={this.state.donationChecked === true ? true : false}

                            icons={{
                                unchecked: <i className='fa fa-times' style={{ fontSize: '13px' }} />,
                                checked: <i className='fa fa-check' style={{ fontSize: '13px' }} />,
                            }}
                            className='custom-Toggle2-color'
                            onChange={(e) => {

                                this.setState({ donationChecked: e.target.checked ? true : false }, () => {
                                    this.balToPay();
                                });
                                let _paymentObj = this.state.paymentObj
                                {
                                    !this.state.donationChecked &&
                                        (_paymentObj.donationAmt = 0,
                                            _paymentObj.donationNoOfMeals = '')
                                    this.setState({ paymentObj: _paymentObj }, () => {
                                        this.balToPay();
                                    })
                                }
                            }}
                        />
                        <label className='custom-label' style={{ lineHeight: '15px', paddingBottom: '7px', verticalAlign: 'middle', paddingLeft: '10px' }}>Would you like to donate for school?</label>
                    </div>
                    }
                    <div className='col-md-12'>
                        {this.state.donationChecked == true &&

                            <div className="row alert-success" >
                                <Fragment>
                                    <div className="col-md-12" style={{ padding: '10px', border: '##dff0d8 solid 2px' }}>
                                        <div className="col-md-4 col-xs-12" style={{ padding: '0px' }}>
                                            <span className="label-text">Donation Amount </span>
                                            <div className="form-group">
                                                <div class="input-group">
                                                    <span className="input-group-addon">{`${this.props.currency_symbol}`}</span>
                                                    <input type="text" className="form-control" id="donationAmt"
                                                        value={this.state.paymentObj.donationAmt}
                                                        placeholder="0" name="donationAmt" onKeyPress={this.isNumeric}
                                                        disabled={this.state.paymentObj.donationNoOfMeals.length > 0}
                                                        onChange={(e) => {
                                                            const _paymentObj = { ...this.state.paymentObj };
                                                            { _paymentObj.donationAmt = e.target.value }

                                                            this.setState({ paymentObj: _paymentObj }, () => {
                                                                this.balToPay()
                                                            });
                                                        }} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4 col-md-offset-3 col-xs-12" style={{ padding: '0px' }}>
                                            <span className="label-text">No. of Meals </span>
                                            <input type="text" className="form-control" id="donationNoOfMeals" value={this.state.paymentObj.donationNoOfMeals}
                                                disabled={this.state.paymentObj.donationAmt.length > 0}
                                                onChange={(e) => {
                                                    const _paymentObj = { ...this.state.paymentObj };
                                                    let mealCount = e.target.value;
                                                    _paymentObj.donationNoOfMeals = mealCount;
                                                    _paymentObj.donationAmt = mealCount * donationPrice

                                                    this.setState({ paymentObj: _paymentObj }, () => {
                                                        this.balToPay()
                                                    });
                                                }}

                                                placeholder={this.props.currency_symbol + donationPrice + " " + 'per meal'} name="donationNoOfMeals" onKeyPress={numberOnly} />
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        <span>**Please enter donation amount (or) No. of meals you want to donate</span>
                                        <hr />
                                    </div>
                                </Fragment>
                            </div>
                        }</div>

                </div>
                <div className="col-md-5">
                    <div className="row">
                        <div className="col-md-12 alert-info" style={{ padding: '10px', border: '#b4e4ef solid 2px' }} >
                            {
                                this.buildTabs(this)
                            }
                        </div>

                    </div>
                    <div className="row text-right">

                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <div className="col-md-7"></div>
            </div>
            {/* <div className="row">
            <div className="col-md-6 col-xs-6">
                <button type="button" className="btn btn-sm btn-success" onClick={(e)=>{
                    this.props.onBackOrderReview(e)
                }}>Back</button>
                </div>    
        </div>   */}
            <Modal isOpen={this.state.showConformMsg}
                style={customStyles}
                contentLabel="Activation"
                ariaHideApp={false} >
                <div className="row text-center">
                    <h5 style={{ color: 'red' }}>Order Confirmation</h5>
                </div>
                <div>

                    {/* <p>Meal account balance is not sufficient for the order.  Do you want to continue with the order?</p> */}
                    {
                        this.state.paymentObj.balAmount < 0 ?
                            <p>Balance amount <strong>{`${this.props.currency_symbol} ${numberParce(-1 * this.state.paymentObj.balAmount - this.donationPrice()).toFixed(2)}`}</strong> will be credited to student Meal Account. Do you want to continue with the order?</p> :
                            this.state.paymentObj.balAmount > 0 ?
                                <p>Balance amount <strong>{`${this.props.currency_symbol} ${numberParce(this.state.paymentObj.balAmount - this.donationPrice()).toFixed(2)}`}</strong> will be debited from student Meal Account. Do you want to continue with the order?</p> :
                                null
                    }

                    <div className="row text-right">
                        <CustomSubmit id="orderSubmit" type="button" className="btn btn-success btn-sm"
                            style={{ marginRight: '5px' }}
                            handleSubmit={(e, callback) => {
                                this.setState({ showConformMsg: false }, () => {
                                    this.adminInstantPaymentSubmit({ lunchBal, paymentObj }, callback, false);
                                });
                                //this.onStudentDataSubmit(e,callback)
                            }}>
                            <i className="glyphicon glyphicon-ok"></i> Proceed</CustomSubmit>

                        <button style={{ margin: '0px' }}
                            className="btn btn-danger btn-sm "
                            onClick={() => {
                                this.setState({ showConformMsg: false });
                            }}>
                            <i className="glyphicon glyphicon-remove"></i> Cancel
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={this.state.showLowBalMsg}
                style={customStyles}
                contentLabel="Activation"
                ariaHideApp={false} >
                <div className="row text-center">
                    <h5 style={{ color: 'red' }}>Low Balance</h5>
                </div>
                {this.props.isAddBalOnline ?
                    <div>
                        <p>Your Meal Account Balance is not sufficient to place the meal order. We request you to fund your Meal Account and return to order screen to place a new order.</p>
                        <div className="row text-right">
                            <button style={{ margin: '0px 2px 0px 0px' }} className="btn btn-success btn-sm " onClick={() => {
                                let row = [];
                                Object.keys(this.props.schoolStudents || {}).forEach((keyname) => {
                                    row = row.concat(this.props.schoolStudents[keyname]);
                                })
                                let payObj = {};
                                payObj.mealSchoolId = row[0].mealSchoolId;
                                payObj.schoolName = row[0].schoolName;
                                payObj.logoUrl = row[0].logoUrl;
                                payObj.transactionType = "Deposit",
                                    payObj.paymentType = "Online",
                                    payObj.transactionDescription = 'Paid amount in advance through online';
                                payObj.totalTransactionAmount = 0.00;
                                payObj.studentWiseTransactions = [];

                                let selectedRows = row;
                                if (selectedRows.length > 0) {
                                    selectedRows.map((r) => {
                                        payObj.studentWiseTransactions.push(
                                            {
                                                studentRecId: r._links.self.href.split("/").pop(),
                                                name: r.firstName + ' ' + r.lastName,
                                                balAmt: r.accBalance,
                                                transactionAmount: 0.00
                                            }
                                        )
                                    });
                                }
                                //this.props.onSelectStudentsForPay(payObj); 
                                if (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') {
                                    this.context.router.history.push('/schoolAdmin/managePayments');
                                }
                                else {
                                    this.context.router.history.push({
                                        pathname: '/parent/checkout',
                                        state: {
                                            onSelectStudentsForPay: payObj
                                        }
                                    });
                                }

                            }}>{(sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') ? 'Go to Add Payments' : 'Go To Add Lunch Balance'}

                            </button>
                            <button style={{ margin: '0px' }}
                                className="btn btn-danger btn-sm "
                                onClick={() => {
                                    this.setState({ showLowBalMsg: false });
                                }}>
                                <i className="glyphicon glyphicon-remove"></i> Cancel
                            </button>
                        </div>
                    </div>
                    :
                    <div>
                        <p>Meal account balance is not sufficient for the order.  Please contact school administrator.</p>
                        <div className="row text-right">
                            <button style={{ margin: '0px 2px 0px 0px' }} className="btn btn-success btn-sm "
                                onClick={() => {

                                    this.context.router.history.push({
                                        pathname: '/parent/'
                                    });

                                }}>Go To Home</button>
                            <button style={{ margin: '0px' }}
                                className="btn btn-danger btn-sm "
                                onClick={() => {
                                    this.setState({ showLowBalMsg: false });
                                }}>
                                <i className="glyphicon glyphicon-remove"></i> Cancel
                            </button>

                        </div>

                    </div>
                }
            </Modal>
        </Fragment>)
    }
}
InstantPayment.contextTypes = {
    router: PropTypes.object.isRequired
}
export default InstantPayment


// WEBPACK FOOTER //
// ./src/components/Parent/ManageOrders/instantPayment.jsx